import React from 'react';
import type { LegalDoc } from '@types';

interface FooterProps {
    onNavigate: (docKey: LegalDoc) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
    return (
        <footer className="bg-white border-t border-slate-200 mt-auto">
            <div className="container mx-auto py-4 px-4 md:px-8 text-center text-xs text-slate-500">
                <p>&copy; {new Date().getFullYear()} IntelOptics Insights. All rights reserved.</p>
                <div className="mt-2 space-x-2 md:space-x-4">
                    <button onClick={() => onNavigate('privacy-policy')} className="hover:text-blue-600 hover:underline">
                        Privacy Policy
                    </button>
                    <span>&bull;</span>
                    <button onClick={() => onNavigate('terms-of-service' as LegalDoc)} className="hover:text-blue-600 hover:underline">
                        Terms of Service
                    </button>
                    <span>&bull;</span>
                    <button onClick={() => onNavigate('data-and-ai-policy' as LegalDoc)} className="hover:text-blue-600 hover:underline">
                        Data and AI Policy
                    </button>
                     <span>&bull;</span>
                    <button onClick={() => onNavigate('legal-disclaimer' as LegalDoc)} className="hover:text-blue-600 hover:underline">
                        Legal Disclaimer
                    </button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;